import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';
import imageRight from '../assets/image-right.png';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState<{ text: string; type: string }>({ text: '', type: '' });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage({ text: '', type: '' });

    try {
      // Get EmailJS configuration from environment variables
      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;

      if (!publicKey || !serviceId || !templateId) {
        throw new Error('EmailJS configuration is missing. Please check your environment variables.');
      }

      // 🔑 Claves deben coincidir con {{name}}, {{email}}, {{phone}}, {{company}}, {{message}} en EmailJS
      const templateParams = {
        name: formData.name,
        email: formData.email.trim() || '—',
        phone: formData.phone.trim(),
        company: formData.company.trim(),
        message: formData.message,
        time: new Date().toLocaleString()
      };

      // Send email using EmailJS
      const response = await emailjs.send(
        serviceId,
        templateId,
        templateParams,
        publicKey
      );

      if (response.status === 200) {
        setMessage({
          text: '¡Gracias por tu mensaje! Te contactaremos pronto.',
          type: 'success'
        });
        setFormData({ name: '', email: '', phone: '', company: '', message: '' });
      } else {
        throw new Error(response.text || 'Error al enviar');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      setMessage({
        text: 'Hubo un error al enviar tu mensaje. Por favor, inténtalo de nuevo.',
        type: 'error'
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id="contacto" className="contact">
      <div className="container">
        <h2 className="section-title">Contáctanos</h2>
        <p className="section-subtitle">
          ¿Listo para que tu empresa evolucione? Hablemos sobre cómo automatizar y optimizar tu gestión
        </p>
        
        <div className="contact-content">
          <div className="contact-image-container">
            <img src={imageRight} alt="Contáctanos - TERA" className="contact-main-image" />
          </div>

          <div className="contact-form">
            <h3>Envíanos un Mensaje</h3>
            {message.text && (
              <div className={`form-message ${message.type}`}>
                {message.text}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Tu nombre"
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Tu email (opcional)"
                  autoComplete="email"
                />
              </div>
              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Teléfono"
                  autoComplete="tel"
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Empresa"
                  autoComplete="organization"
                  required
                />
              </div>
              <div className="form-group">
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Cuéntanos cómo podemos ayudarte a automatizar tu empresa"
                  rows={5}
                  required
                ></textarea>
              </div>
              <button type="submit" className="submit-btn" disabled={isLoading}>
                {isLoading ? 'Enviando...' : 'Enviar Mensaje'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
